import { Outlet } from "react-router-dom";

const Match = () => {
  return <Outlet />;
};

export default Match;
